import React from "react";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";

// Map container styling
const containerStyle = {
  width: "100%",
  height: "500px",
};

// Initial center coordinates for the map (Napa Valley)
const center = {
  lat: 38.2975,
  lng: -122.2869,
};

const MapView = () => {
  return (
    <>
    <div className="p-6">
      <h1 className="text-3xl font-bold mb-6">Map View of Properties</h1>
      <LoadScript googleMapsApiKey="AIzaSyi3JqWbA2w0HOWUO6nsOfnlcyTM"> {/* Replace with your API Key */}
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={center}
          zoom={10}
        >
          {/* Example markers for properties */}
          <Marker position={{ lat: 38.2975, lng: -122.2869 }} />
          <Marker position={{ lat: 38.5052, lng: -122.4704 }} />
          <Marker position={{ lat: 38.7749, lng: -122.4194 }} />
        </GoogleMap>
      </LoadScript>
    </div>
    <div className="my-10">
    </div>
    </>
  );
};

export default MapView;
